"use strict";
const defaultMenuProvider_1 = require("./default/defaultMenuProvider");
const menuProvider_1 = require("./interfaces/menuProvider");
exports.DEFAULT_MENU_PROVIDER_ENTRY = { provide: menuProvider_1.IMENUPROVIDERSERVICE_TOKEN, useClass: defaultMenuProvider_1.DefaultMenuProvider, multi: false };
